import "core-js/modules/es.array.concat.js";
// Duplicated from ab-common
import moment from 'moment-timezone/builds/moment-timezone-with-data';
import { TIMESTAMP_MIN_WITH_OFFSET, TIMESTAMP_MAX_WITH_OFFSET } from "../constants/dateFormats";
export var dateFormat = 'YYYY-MMM-DD';
export var dateFormatNumbersOnly = 'YYYY-MM-DD';
export var dateTimeFormat = 'YYYY-MMM-DD HH:mm';
export var dateTimeSecondsFormat = 'YYYY-MM-DD HH:mm:ss';
export var formatDate = function formatDate(time) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : dateFormat;
  if (!time) return null;
  return moment(time).format(format);
};
export var formatDateWithBackendOffset = function formatDateWithBackendOffset(time) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : dateFormat;
  if (!time) return null;
  return moment(time).utcOffset('-04:00').format(format);
};
export var formatDateForBackend = function formatDateForBackend(time, maxTimestampForDate) {
  if (!time) return null;
  var date = moment.utc(time).format(dateFormatNumbersOnly);
  if (maxTimestampForDate) return "".concat(date, "T").concat(TIMESTAMP_MAX_WITH_OFFSET);
  return "".concat(date, "T").concat(TIMESTAMP_MIN_WITH_OFFSET);
};
export var formatDateLocal = function formatDateLocal(time) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : dateFormat;
  if (!time) return null;
  return moment(time).local().format(format);
};
export var formatDateTime = function formatDateTime(time) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : dateTimeFormat;
  if (!time) return null;
  return moment(time).format(format);
};
export var formatDateToronto = function formatDateToronto(time) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : dateFormat;
  if (!time) return null;
  return moment.tz(time, 'America/Toronto').format(format);
};
export var monthDifference = function monthDifference(date1, date2) {
  if (!date1 || !date2) throw new Error('Both dates need to be valid');
  return moment(date1).diff(moment(date2), 'months');
};